export default {
    TERMO_COMPROMISSO_ESTAGIO: 61,
    TERMO_COMPROMISSO_ESTAGIO_EAD: 108,
    TERMO_COMPROMISSO_ESTAGIO_MEDICINA: 137
};



// WEBPACK FOOTER //
// ./src/domain/protocolo/ProtocoloEnum.js